module.exports = __webpack_public_path__ + "static/media/291753.81aedc76.png";